export default (props) => (
  <svg {...props} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M9.476 10.666c.114.445.925.446 1.04.001L11 5.784C11 5.351 10.553 5 10 5c-.552 0-1 .351-1 .784l.476 4.882zM9.933 13C9.418 13 9 13.448 9 14s.418 1 .933 1h.134c.516 0 .933-.448.933-1s-.417-1-.933-1h-.134z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M10 2a8 8 0 110 16 8 8 0 010-16zm0 1a7 7 0 100 14 7 7 0 000-14z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);
